import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText, FDStack } from '@facet-wealth/design';
import Typography from 'Components/UI/Typography';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';


const useStyles = buildUseStyles('WelcomeTitleAndSubtitle', () => ({
  title: {
    fontSize: '32px',
    textAlign: 'center',
  },
}));

function WelcomeInfoTitleAndSubtitle({ title, subtitle }) {
  const classes = useStyles();

  return (
    <FDStack direction={'column'} spacing={4} alignItems={'center'}>
      <Typography
        className={classes.title}
        variant={'h1'}
        color={'primary'}
        weight={'medium'}
      >
        {title}
      </Typography>
      <FDStack spacing={3} direction={'column'} alignItems={'center'}>
        {
          subtitle?.map((text) => {
            return <FDBodyText key={text} value={text} color={'textDisabled'} align={'center'} />;
          })
        }
      </FDStack>
    </FDStack>
  );
}

WelcomeInfoTitleAndSubtitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.arrayOf(PropTypes.string).isRequired,
};

WelcomeInfoTitleAndSubtitle.defaultProps = {
};

export default WelcomeInfoTitleAndSubtitle;
